var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.844116 8.179C0.844116 3.715 4.45454 0.104584 8.91854 0.104584C13.3825 0.104584 16.993 3.715 16.993 8.179C16.993 12.989 11.8945 19.6216 9.80672 22.1477C9.34533 22.7014 8.50328 22.7014 8.04188 22.1477C5.94253 19.6216 0.844116 12.989 0.844116 8.179ZM6.03481 8.17904C6.03481 9.77085 7.32672 11.0628 8.91854 11.0628C10.5103 11.0628 11.8023 9.77085 11.8023 8.17904C11.8023 6.58722 10.5103 5.29532 8.91854 5.29532C7.32672 5.29532 6.03481 6.58722 6.03481 8.17904Z",
    fill: "#F12B2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationlogo);
export default __webpack_public_path__ + "static/media/Locationlogo.722f81fcf127e48d20fb6958e03b9c72.svg";
export { ForwardRef as ReactComponent };